import { fetchLanguage } from '@/api/lang/lang'
import { EGlobalConfig } from '@/enums/cacheEnum'
import { useStorage } from '@/hooks/system/useStorage'
import { transformLangData } from '@/utils/lang'

const dbKey = 'LANG_'

/** 本地缓存读取多语言数据 */
export async function useLangDB(langKey: string) {
  try {
    const langFormatDb = await useStorage.db.get(`${dbKey}${langKey}`)
    if (langFormatDb) {
      return langFormatDb
    } else {
      return {}
    }
  } catch (err) {
    return {}
  }
}

/** 接口读取多语言数据 */
export async function useLangApi(langKey: string, localLang?: {}) {
  let langApi = {}
  try {
    if (useStorage.ls.get(EGlobalConfig.token)) langApi = await fetchLanguage()
  } catch (err) {
  }

  const langFormat = transformLangData(langApi, langKey)

  useStorage.db.set(`${dbKey}${langKey}`, { ...localLang, ...langFormat })

  return langFormat
}
